import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowRightSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.9395 8.75L14.4395 11.25H7V12.75H14.4395L11.9395 15.25L13 16.3105L17.3105 12L13 7.68945L11.9395 8.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRightSquare;
